import template from './log.html'

const pageLog = () => {
  return {
    title: 'Log',
    async init() {
      this.$nextTick(_ => {
        this.$el.innerHTML = template
      })
    }
  }
}

export { pageLog }
